export default __webpack_public_path__ + "static/fax_compare_comp2_inactive-7a72023d8f56357db7c881dc66cfe91f.png";